import { useEffect } from "react";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useAuthStore } from "@/stores/auth-store";
import { AUTH_ROUTES, PROTECTED_ROUTES } from "@/utils/navigation";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (isAuthenticated()) {
      router.navigate({ to: PROTECTED_ROUTES.CALENDAR, replace: true });
    } else {
      router.navigate({ to: AUTH_ROUTES.SIGN_IN, replace: true });
    }
  }, [isAuthenticated, router]);

  return null;
}
